<template>
  <div id="defaultLayout">
    <section id="NAV">
      <MyHeader
        :cur-locale="locale"
        :locale-list="localeList"
        @i18n:update="updateI18n"
      />
    </section>
    <section id="MAIN">
      <Nuxt />
    </section>
    <MyFooter :synopsis-visible="synopsisVisible" />
    <Loading v-if="$store.state.isLoading" />
  </div>
</template>

<script>
import Loading from '_c/loading'
import MyHeader from '../components/global/header.vue'
import MyFooter from '../components/global/footer.vue'
import i18nMixins from './i18n-mixin'

export default {
  components: {
    MyHeader,
    MyFooter,
    Loading
  },
  mixins: [i18nMixins],
  data() {
    return {
      synopsisVisible: true
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        this.synopsisVisible = to.path === '/'
      }
    }
  },
  mounted() {
    this.initI18n()
    if (this.$route.query.lang) {
      this.updateI18n(this.$route.query.lang)
      // 避免路径中带有lang,设置语言后刷新页面还是会按照路径中的lang设置
      this.$router.replace(this.$route.path)
    }
    this.$Message.config({
      top: 100,
      duration: 3.5
    })
    this.$Notice.config({
      top: 100,
      duration: 3.5
    })
  }
}
</script>

<style lang="scss">
/* 这里是全局的 */
html {
  height: 100%;
  // font-family: 'Source Sans Pro',
  // -apple-system, BlinkMacSystemFont, 'Segoe UI',
  //   Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, 'Noto Sans', 'Liberation Sans', sans-serif,
    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
    'Noto Color Emoji';
  font-size: 100px;
}

body {
  min-width: 1366px;
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, 'Noto Sans', 'Liberation Sans', sans-serif,
    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
    'Noto Color Emoji';
  // font-size: $f16;
}

*,
*:before,
*:after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

#defaultLayout {
  height: 100%;
}

#NAV {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  box-shadow: 0 0 3px #b5b5b5;
}
#MAIN {
  padding-top: $navHeight;
  min-height: calc(100vh - (1.5rem + 0.4rem * 2));
}
</style>
